import React from 'react'

const ArrowUpIcon = (props: any = {}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={props?.size ?? 20} height={props?.size ?? 20} viewBox="0 0 20 20" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M3.69344 12.9067C3.91808 13.1688 4.31265 13.1992 4.57472 12.9745L10.0013 8.32316L15.4279 12.9745C15.69 13.1992 16.0845 13.1688 16.3092 12.9067C16.5338 12.6447 16.5035 12.2501 16.2414 12.0255L10.4081 7.02545C10.174 6.82483 9.82862 6.82483 9.59457 7.02545L3.76124 12.0255C3.49916 12.2501 3.46881 12.6447 3.69344 12.9067Z" fill={props?.color ?? 'var(--primary)'} />
        </svg>
    )
}

export default ArrowUpIcon